import { render, staticRenderFns } from "./my-account.vue?vue&type=template&id=6b0fee7e&"
import script from "./my-account.vue?vue&type=script&lang=js&"
export * from "./my-account.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/views/auth/my-account.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports